<template>
   <div class="layout-page">
      <h1>Communication Preferences</h1>

      <div class="container-fluid">
         <div class="row mart-24 marb-24">
            <div class="col-sm-8">
               <commprefs :userId="extUserId" @on-done="finished"></commprefs>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import CommPrefs  from '@/components/CommPrefs.vue'

export default {
   name: "Communications",
   components: { 'commprefs': CommPrefs },
   data() {
      return {
         extUserId: '',
         extUserName: '',
         loading: true
      };
   },
   created() {
      this.$parent.loadingStart()
      this.loading = true
      let u = this.$store.getters.appUser
      this.extUserId = u.userId
      this.extUserName = u.userName
   },
   async mounted() {
      // Reminder: Child components mounted first. Let them finish...
      this.$nextTick(()=>{
         this.loading = false
         this.$parent.loadingEnd()
      })
   },
   methods: {
      finished() {
         this.$router.push({name: 'home' })
      }
   }
};
</script>

<style scoped>
#tslink:visited {
   color: #fff;
}
</style>